import { BasketManagerFilterProps } from '@epicuro-next/constants/features/full-basket-manager';
import { BasketManagerTableComponent } from '@epicuro-next/platform/dynamic-components';

import { BasketManagerTableProps } from '../models';

export const basketManagerComponents = {
  [BasketManagerTableProps.Brands]: {
    contentTypeId: BasketManagerTableComponent.Collapse,
    data: { show: 1 },
  },
  [BasketManagerTableProps.Accounts]: {
    contentTypeId: BasketManagerTableComponent.Collapse,
    data: { show: 2 },
  },
  [BasketManagerTableProps.LastUpdated]: {
    contentTypeId: BasketManagerTableComponent.DateTime,
    data: {
      dateFormat: 'mediumDate',
      timeFormat: 'h:mm a',
    },
  },
  [BasketManagerTableProps.Status]: {
    contentTypeId: BasketManagerTableComponent.StatusBadge,
    data: {},
  },
  [BasketManagerTableProps.OrderType]: {
    contentTypeId: BasketManagerTableComponent.OrderType,
    data: {},
  },
  [BasketManagerTableProps.CreatedBy]: {
    contentTypeId: BasketManagerTableComponent.User,
    data: {},
  },
  [BasketManagerTableProps.Value]: {
    contentTypeId: BasketManagerTableComponent.Value,
    data: {},
  },
  [BasketManagerTableProps.Quantity]: {
    contentTypeId: BasketManagerTableComponent.GenericCell,
    data: {},
  },
  [BasketManagerTableProps.ClientReferenceNumber]: {
    contentTypeId: BasketManagerTableComponent.GenericCell,
    data: {},
  },
  [BasketManagerTableProps.SubmittedBy]: {
    contentTypeId: BasketManagerTableComponent.User,
    data: {},
  },
} as const;

export const basketManagerMandatoryColumns = [BasketManagerTableProps.Checkbox];

export const basketManagerDefaultColumns: BasketManagerTableProps[] = [
  BasketManagerTableProps.OrderReferenceNumber,
  BasketManagerTableProps.ClientReferenceNumber,
  BasketManagerTableProps.LastUpdated,
  BasketManagerTableProps.CreatedBy,
  BasketManagerTableProps.Status,
  BasketManagerTableProps.Accounts,
  BasketManagerTableProps.Quantity,
  BasketManagerTableProps.Value,
];

export const basketManagerDefaultFilters = [
  BasketManagerFilterProps.Accounts,
  BasketManagerFilterProps.DatesRange,
  BasketManagerFilterProps.OrderType,
  BasketManagerFilterProps.Status,
  BasketManagerFilterProps.User,
  BasketManagerFilterProps.Search,
];

export const INCLUDED_FILTERS_KEY = 'includedFilters';
